import __var_0__ from './cphase.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Compute the argument of a complex number in radians.
*
* @module @stdlib/math/base/complex/phase
*
* @example
* var cphase = require( '@stdlib/math/base/complex/phase' );
*
* var phi = cphase( 5.0, 3.0 );
* // returns ~0.5404
*/

// MODULES //
var cphase = __var_0__;


// EXPORTS //
export default cphase;
